import CityPageTemplate from "../city-template/CityPageTemplate";
import { amarilloConfig } from "./data";

export default function AmarilloPage() {
  return <CityPageTemplate config={amarilloConfig} />;
}